export default function Loading({ label = 'Loading...' }) {
  return (
    <div className="min-h-screen bg-surface flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue mx-auto mb-3"></div>
        <p className="text-ink-muted text-sm">{label}</p>
      </div>
    </div>
  );
}
